import { Record } from 'immutable';
const DeliveryIdentifier = Record({
  type: '',
  value: ''
}, 'DeliveryIdentifier');
export default DeliveryIdentifier;